import { Common, color } from '@stockbit/ui';
import { Carousel } from 'antd';
import Image from 'global/Image';
import styled from 'styled-components';

const { Flex } = Common;

export const AuthModalCarousel = styled(Carousel)`
  position: relative;
  top: -24px;

  .slick-prev,
  .slick-next {
    z-index: 1;
    display: none !important;
  }

  &:hover .slick-prev,
  &:hover .slick-next {
    display: block !important;
  }

  .slick-next {
    right: 16px;
  }

  .slick-prev {
    left: 16px;
  }

  .slick-dots {
    width: auto;

    li {
      width: 2px;
      bottom: -24px;
    }

    li button {
      background: gray;
      width: 5px;
      height: 5px;
      border-radius: 10px;

      &::before {
        display: none;
      }
    }

    li.slick-active {
      width: 13px;
      margin-right: 0;
    }

    li.slick-active button {
      width: 13px;
      height: 5px;
      background: ${color.primary};
      border: unset;
    }
  }
`;

export const CarouselItemContainer = styled(Flex)`
  width: 300px !important;
  margin: auto;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const CarouselImage = styled(Image)`
  margin: 0 auto 24px;
  width: 200px;
  height: 200px;
`;
